import { render, staticRenderFns } from "./RecuperoCredenziali.vue?vue&type=template&id=41a92dfe&"
import script from "./RecuperoCredenziali.vue?vue&type=script&lang=js&"
export * from "./RecuperoCredenziali.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports